import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useClickOutside } from '@pascal/pascal-core';

import WinChanceCounter from '../winChanceCounter';
import { gameStore } from '../../store/gameStore';
import { doBetStore } from '../../store/doBetStore';
import { TranslationKeys } from '../../enums/translationKeys';
import { GAME_NUM_PAD_BUTTON_VALUE } from '../../enums/constants';
import { useAmountValidation } from '../../hooks/useAmountValidation';

export const NumPad = observer(() => {
  const [numPadOdd, setNumPadOdd] = useState(null);
  const { isOpenNumPad, setIsOpenNumPad } = gameStore;
  const { selectedOdd, setSelectedOdd } = doBetStore;
  const [numPadRef, hasNumPadClickedOutSide] = useClickOutside();
  const { onChange: handleChangeOddValue } = useAmountValidation(setNumPadOdd);

  useEffect(() => {
    if (isOpenNumPad) {
      setNumPadOdd(selectedOdd);
    }
  }, [isOpenNumPad, selectedOdd]);

  const handleClickButton = (e, dot) => {
    e.stopPropagation();
    let odd;
    if (dot) {
      if (!numPadOdd.toString().includes('.')) {
        odd = numPadOdd.toString() + e.target.textContent;
      }
    }
    if (numPadOdd.toString().length < 7) {
      odd = numPadOdd.toString() + e.target.textContent;
    }
    handleChangeOddValue({ target: { value: odd } });
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    const odd = numPadOdd.toString().slice(0, -1);
    if (!odd) {
      setNumPadOdd('');
    } else {
      setNumPadOdd(odd);
    }
  };

  const handleOK = (e) => {
    e.stopPropagation();
    setSelectedOdd(numPadOdd);
    setIsOpenNumPad(false);
  };

  useEffect(() => {
    if (hasNumPadClickedOutSide) {
      setIsOpenNumPad(false);
      setNumPadOdd(null);
    }
  }, [hasNumPadClickedOutSide, setIsOpenNumPad]);

  return (
    isOpenNumPad && (
      <div className='mobile-num-pad'>
        <div className='mobile-num-pad-body' ref={numPadRef}>
          <div className='mobile-num-pad-fields'>
            <WinChanceCounter
              numPadOdd={numPadOdd}
              setNumPadOdd={setNumPadOdd}
              numPadOnChange={handleChangeOddValue}
            />
          </div>
          <div className='mobile-numpad-bnt-panel'>
            <div className='mobile-numpad-top'>
              <div className='mobile-numpad-nums'>
                {GAME_NUM_PAD_BUTTON_VALUE.map((item) => (
                  <button type='button' key={item} onClick={(e) => handleClickButton(e)}>
                    {item}
                  </button>
                ))}
              </div>
              <div className='mobile-numpad-aside'>
                <button type='button' onClick={(evt) => handleDelete(evt)}>
                  <i className='icon-backspace' />
                </button>
                <button type='button' onClick={(e) => handleClickButton(e, true)}>
                  .
                </button>
              </div>
            </div>
            <div className='mobile-numpad-actions'>
              <button
                type='button'
                onClick={() => {
                  setNumPadOdd(null);
                  setIsOpenNumPad(false);
                }}
              >
                <i className='icon-chevron' />
              </button>
              <button type='button' onClick={(e) => handleOK(e)}>
                {TranslationKeys.OK}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
});
